// export * from "../../../node_modules/.prisma/client";
module.exports = require("../../../node_modules/.prisma/client");
